import { render, staticRenderFns } from "./EditImageBlockModal.vue?vue&type=template&id=dd4d4d04&lang=pug&"
import script from "./EditImageBlockModal.vue?vue&type=script&lang=js&"
export * from "./EditImageBlockModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports